document.addEventListener('rebuy.beforeReady', (event) => {
  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('img[data-src]').forEach(element => {
          element.src = element.dataset.src;
        });
        observer.disconnect();
      }
    });
  };

  const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
  };
  const observer = new IntersectionObserver(callback, options);

  const targets = document.querySelectorAll('.rebuy-product-grid.js-lazy');
  targets.forEach(target => {
    observer.observe(target);
  })
});

if (Shopify.theme_settings.scheduled_discount) {
  document.addEventListener('rebuy.ready', function(event){
    const container = event.detail.widget.template;
    const priceContainers = container?.querySelectorAll('.rebuy-product-price .rebuy-money:not(.compare-at) span:last-of-type');
    priceContainers.forEach(priceEl => {
      const currencySymbol = priceEl.innerText[0];
      const priceValue = priceEl.innerText.replace(currencySymbol, '');
      const discountedPrice = (priceValue * 100 * Shopify.theme_settings.scheduled_discount / 100).toFixed(2);
      const priceContainer = priceEl.closest('.rebuy-money');
      priceContainer?.classList.toggle('scheduled-compare-at', true);
      const discountedPriceEl = `<span class="rebuy-money sale"><span class="sr-only">Price</span><span>${currencySymbol}${discountedPrice}</span></span>`
      priceContainer.insertAdjacentHTML('beforebegin', discountedPriceEl);
    })
  }); 
}